import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../../../config/endpoints.config';
import { map } from 'rxjs/operators';
import {UserLoginInfoDto } from '../../../../models/UserLoginInfoDto';
@Injectable({
  providedIn: 'root'
})
export class SrcExamForgotPasssService {
  constructor(private http: HttpClient) { }
  Fogot(sLoginDto: UserLoginInfoDto ) {
    return this.http.post(EndpointsConfig.examinee.forgot,
      JSON.stringify(sLoginDto));
  }
  CheckTime(sLoginDto: UserLoginInfoDto ) {
    return this.http.post(EndpointsConfig.examinee.ChekTiemSendMail,
      JSON.stringify(sLoginDto));
  }
}
